export const GET_PROGRAM_TAGS = 'GET_PROGRAM_TAGS';
export const GET_PROGRAM_TAG_BY_ID = 'GET_PROGRAM_TAG_BY_ID';
export const UPDATE_PROGRAM_TAG = 'UPDATE_PROGRAM_TAG';
export const DELETE_PROGRAM_TAG = 'DELETE_PROGRAM_TAG';
export const CREATE_PROGRAM_TAG = 'CREATE_PROGRAM_TAG';
